import React from 'react'

import {
  Box,
  Grid,
  Typography,
} from '@mui/material'

const LandingHow = (props) => {
  return (
    <Grid container spacing={2} p={8} py={8} style={{ backgroundColor: '#ffffff', backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%234a4280' fill-opacity='0.06' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E")` }} alignItems='center'>
      <Grid item xs={12} md={6}>
        <Typography color='primary' variant='h3' gutterBottom>
          <b style={{ fontWeight: 900 }}>¿Cómo funciona?</b>
        </Typography>
        <Typography color='#00c08b' variant='h5' gutterBottom>
          <b style={{ fontWeight: 700 }}>Iluminando el camino</b>
        </Typography>
        <Typography variant='body1'>
          <b style={{ fontWeight: 700 }}>Light Spot®</b> busca ser una herramienta que facilite la preceptoría,   ayudando al preceptor a darle un seguimiento adecuado al alumno y a los papás. Todo gira en torno a la lucha por vivir mejor las virtudes     cristianas, concretando en metas que el preceptor y el alumno deciden en cada preceptoría y siguiendo su desarrollo utilizando Light spot.
        </Typography>
      </Grid>
      <Grid item xs={12} md={6} align='center' sx={{ display: { xs: 'none', md: 'block' } }}>
        <Box
          component='img'
          src='/assets/images/how-circle.png'
          sx={{ width: '80%' }}
        />
      </Grid>
    </Grid>
  )
}

export default LandingHow